
export default {
    menuHide: false,
    menuCollapse: false,
    mainMenu: 'welcome',    //废弃
    menus: [],
    menuGroups: [],
    subGroups: [],
    currentMenuType: '',
    currentMenu: {},
    openGroup: {},
    loginUser: {},
    loginCust: {},
    loginType: '',
    project: null,
    dyncCompLoaded: {}
};
